export type AssetFilterReferenceDateType =
  | 'All'
  | 'CreatedWithoutLicense'
  | 'LicenseAssignedNotActivated'
  | 'MapDataOverDate';

export const assetFilterReferenceDateTypeLookup = new Map<
  AssetFilterReferenceDateType,
  number
>([
  ['All', 0],
  ['MapDataOverDate', 1],
  ['CreatedWithoutLicense', 2],
  ['LicenseAssignedNotActivated', 3],
]);
